<template>
    <div>
        <!-- 仓库配置 -->
        <compWrapper title="仓库配置" theme="primary" >
        <Form class="margin-top-15">
            <FormItem :label="$t('fbb.warehouse.can_use_warehouse',{defaultValue:'可使用的仓库'})" label-width="150" >
                <Transfer
                    :data="warehouseList"
                    filterable
                    :target-keys="targetKeys"
                    :list-style="listStyle"
                    :render-format="renderFormat"
                    :filter-method="filterMethod"
                    @on-change="handleAccountChange"
                ></Transfer>
            </FormItem>
        </Form>
        </compWrapper>
        <!-- 目标指标配置 -->
        <compWrapper title="目标指标配置" theme="primary" >
            <compFormEdit ref="formbase" class="margin-layout" :formdata="getBase" v-model="formData"></compFormEdit>
            <div class="text-right">
                <Button type="primary" class="margin-right-15" @click="submit">保存</Button>
            </div>
        </compWrapper>

    </div>
</template>

<script>
import TableList from "@components/templates/tablelist";
import { HttpSaveStorageKpiSetting, HttpGetStorageKpiSetting } from '@/service/report';
import { mapGetters } from 'vuex';
export default {
    props: ['data'],
	components: {
		TableList
	},
	data() {
		return {
			type: this.$route.params.type,
			id: this.$route.query.id,
			targetKeys: [],
			listStyle: {
				width: '30%',
				minWidth: '260px',
                height:'300px'
			},
            formData:{},
		}
	},
    async created(){
        // 获取上一次的保存结果
        await HttpGetStorageKpiSetting().then(res=>{
            this.formData = res.data;
            this.targetKeys = res.data.warehouseKpiCfgEntityList.map(item=>{
                return item.warehouseId
            })
        })
    },
	computed: {
		...mapGetters('dictionary', ['getBillcusWareList']),
        warehouseList(){
            return this.getBillcusWareList.map((item) => {
                return {
                    label: item.label,
                    key: item.value,
                };
            });
        },
        getBase(){
            return [{
				label: '上架及时率',
				key: "shelfOnTimeRate",
                children:(h)=>{
                    return <span slot='suffix' class="padding-left-10 padding-right-10">%</span>
                }
			}, {
				label: '发货及时率(综合)',
				key: "deliveryOnTimeRate",
                children:(h)=>{
                    return <span slot='suffix' class="padding-left-10 padding-right-10">%</span>
                }
			}, {
				label: '发货准确率',
				key: "deliveryAccuracyRate",
                children:(h)=>{
                    return <span slot='suffix' class="padding-left-10 padding-right-10">%</span>
                }
			}, {
				label: 'Fedex上网率',
				key: "fedexOnlineRate",
                children:(h)=>{
                    return <span slot='suffix' class="padding-left-10 padding-right-10">%</span>
                }
			}, {
				label: 'UPS上网率',
				key: "upsOnlineRate",
                children:(h)=>{
                    return <span slot='suffix' class="padding-left-10 padding-right-10">%</span>
                }
			}, {
				label: 'Fedex妥投率',
				key: "fedexDeliveryRate",
                children:(h)=>{
                    return <span slot='suffix' class="padding-left-10 padding-right-10">%</span>
                }
			}, {
				label: 'UPS妥投率',
				key: "upsDeliveryRate",
                children:(h)=>{
                    return <span slot='suffix' class="padding-left-10 padding-right-10">%</span>
                }
			}]
        }
	},
	methods: {
		renderFormat(item) {
			return item.description ? `${item.label}-${item.description}` : item.label;
		},
		handleChange(targetKeys, direction, moveKeys) {
			this.targetKeys = targetKeys;
		},
        // 添加自定义搜索函数,不区分大小写
        filterMethod (data, query) {
            return data.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
        },
        handleAccountChange(newTargetKeys, direction, moveKeys) {
            this.targetKeys = newTargetKeys;
        },
        submit(){
            HttpSaveStorageKpiSetting({
                ...this.formData,
                warehouseIds:this.targetKeys,
            }).then(res=>{
                this.$Message.success(res.message)
            },err=>{
                this.$Message.error({
                    content:err.message,
                    duration:10,
                    closable:true,
                })
            })
        }
	}
}
</script>
